import {useQuery} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import ChessRestClient from '@/Api/ChessRestClient';

export default function useGetOpeningIntelligenceReportApi(
  {
    assessmentId,
    tournamentId,
    enabled = true,
    onSuccess,
    onError,
  }: {
    assessmentId?: string;
    tournamentId?: number | string;
    enabled?: boolean;
    onSuccess?: (data: any) => void;
    onError?: (error: any) => void;
  } = {},
) {
  return useQuery(
    ['openingIntelligenceReport', assessmentId, tournamentId],
    async () => {
      const token = await getLocalStorage('access_token');
      const params: Record<string, string | number> = {};
      if (assessmentId) {
        params.assessment_id = assessmentId;
      }
      if (tournamentId !== undefined && tournamentId !== null) {
        params.tournamentId = tournamentId;
      }
      const response = await ChessRestClient.get(
        'assessment/v1/learning/get_opening_intelligence_report/',
        {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );
      return response.data;
    },
    {
      enabled: Boolean(enabled && (assessmentId || tournamentId)),
      onSuccess,
      onError,
      retry: (failureCount, err: any) => {
        const status = err?.response?.status;
        if (status === 404) return false; // report not generated / not found
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
    },
  );
}
